import { isValidElement } from "react";

import type { IDropdownChild, IDropdownItem } from "@similarweb/ui-components";

import type {
    GscWizardSyncStatus,
    SavedGscMarket,
    StandardGscDraft,
} from "app/pages/digital-marketing/keywords-campaigns/shared/gsc-import/types";

/**
 * Case-insensitive text search filter for ui-components Dropdown.
 * Matches against `item.props.text`; non-React-element items are excluded.
 */
export const dropdownTextSearchFilter = (term: string, item: IDropdownChild): boolean => {
    if (!term) {
        return true;
    }
    if (!isValidElement<IDropdownItem>(item)) {
        return false;
    }
    const text = item.props.text;
    return text?.toLowerCase().includes(term.toLowerCase()) ?? false;
};

export const hasGscSyncStatusErrors = (status: GscWizardSyncStatus): boolean => {
    return (
        !status.hasSelectedSite ||
        status.savedMarketsCount === 0 ||
        status.trackedKeywordsCount === 0 ||
        status.hasUnsavedMarket
    );
};

// Wizard state keeps the standard-flow reopen draft as a serializable array, but the modal logic
// works more naturally with a Map keyed by fixed-config index.
export const buildSavedMarketsMap = (initialDraft?: StandardGscDraft | null): Map<number, SavedGscMarket> => {
    return new Map(initialDraft?.savedMarkets.map(({ configIndex, market }) => [configIndex, market]) ?? []);
};
